import React, { type ReactElement, useEffect, useMemo, useState } from 'react';
import { Box } from '@saviynt/design-system';

import {
  TABS_FILTERS,
  VIOLATIONS_LIST_SIDEPANEL_TABS,
} from '../../../../shared/constants';
import { useTypedSelector } from '../../../../shared/hooks';
import { type ViolationsTabSidePanelRowContextState } from '../../data-layer/violationsTabTypes';

import ViolationsSidePanelHistory from './ViolationsSidePanelHistory';
import ViolationsSidePanelSummary from './ViolationsSidePanelSummary';
import ViolationsSidePanelTabs from './ViolationsSidePanelTabs';
import ViolationsSidePanelUser from './ViolationsSidePanelUser';

import './ViolationsSidePanelBody.css';

interface ViolationsSidePanelBodyProps {
  currentRowContext: ViolationsTabSidePanelRowContextState;
  sidepanelRef: React.RefObject<HTMLDivElement>;
}

/**
 * ViolationsSidePanelBody
 */
function ViolationsSidePanelBody({
  sidepanelRef,
  currentRowContext,
}: ViolationsSidePanelBodyProps): ReactElement {
  const {
    controls: { tabInAction },
  } = useTypedSelector((state) => state.aag.violationsTab);

  const [activeTab, setActiveTab] = useState(
    VIOLATIONS_LIST_SIDEPANEL_TABS.TAB_SUMMARY
  );

  useEffect(() => {
    setActiveTab(VIOLATIONS_LIST_SIDEPANEL_TABS.TAB_SUMMARY);
  }, [currentRowContext.id]);

  const isMitigatedTab = useMemo(
    () => Boolean(tabInAction === TABS_FILTERS.MITIGATEDCOUNT.value),
    [tabInAction]
  );

  const handleChange = (value: string) => setActiveTab(value);

  return (
    <Box tag='div' className='Sod-ViolationsSidePanelBody-wrapper'>
      <ViolationsSidePanelTabs
        activeTab={activeTab}
        handleChange={handleChange}
        sidepanelRef={sidepanelRef}
      />
      <ViolationsSidePanelSummary
        currentRowContext={currentRowContext}
        activeTab={activeTab}
        handleChange={handleChange}
        isMitigatedTab={isMitigatedTab}
      />
      <ViolationsSidePanelHistory
        currentRowContext={currentRowContext}
        activeTab={activeTab}
      />
      <ViolationsSidePanelUser
        currentRowContext={currentRowContext}
        activeTab={activeTab}
      />
    </Box>
  );
}

export default ViolationsSidePanelBody;
